var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59172 2.18505C3.1103 1.75709 3.77513 1.5 4.5 1.5H10.5H19.5C21.1569 1.5 22.5 2.84315 22.5 4.5L22.5 7.5V16.5L22.5 19.5C22.5 21.1569 21.1569 22.5 19.5 22.5L10.5 22.5L4.5 22.5C2.84315 22.5 1.5 21.1569 1.5 19.5V16.5V7.5V4.5C1.5 4.39645 1.50525 4.29412 1.51549 4.19327C1.57015 3.65506 1.76707 3.15891 2.06806 2.74302C2.21828 2.53546 2.39441 2.34789 2.59172 2.18505ZM10.5 19.5H19.5V16.5H10.5V19.5ZM10.5 13.5H19.5V10.5H10.5L10.5 13.5ZM7.5 10.5L7.5 13.5H4.5V10.5H7.5ZM10.5 7.5H19.5V4.5L10.5 4.5V7.5ZM7.5 4.5L4.5 4.5V7.5H7.5V4.5ZM4.5 16.5H7.5V19.5L4.5 19.5V16.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleTable);
export default __webpack_public_path__ + "static/media/Toggle-Table.bd81c4d173cd9134aa6f28158f60be29.svg";
export { ForwardRef as ReactComponent };